<h2 class="default-dialog-header" mat-dialog-title>
	<div fxFlex>Quality</div>
	<div fxFlex="10" fxLayoutAlign="end start">
		<mat-icon (click)="closeDialog(null)" class="primary-light-color cursor-pointer"
			>close</mat-icon
		>
	</div>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content m-b-1">
	<app-quality
		class="full-width"
		[carrierId]="data?.carrierId"
		[destinationCity]="data?.destination?.city"
		[destinationState]="data?.destination?.state"
		[originCity]="data?.origin?.city"
		[originState]="data?.origin?.state"
		[mc]="data?.mc"
		[dot]="data?.dot"
		[carrierActive]="data.active"
		[isCarrierInNetwork]="data?.isCarrierInNetwork"
		[ccBookingRateDisplay]="data.ccBookingRateDisplay"
		[ccEngagementRateDisplay]="data.ccEngagementRateDisplay"
		[ccFalloffRateDisplay]="data.ccFalloffRateDisplay"
		[ccTotalBookedLoads]="data.ccTotalBookedLoads"
		[ccScore]="data.ccScore"
		[vettingOverallDisplay]="data.vettingOverallDisplay"
		[vettingAuthorityDisplay]="data.vettingAuthorityDisplay"
		[vettingInsuranceDisplay]="data.vettingInsuranceDisplay"
		[vettingOperationsDisplay]="data.vettingOperationsDisplay"
		[vettingSafetyDisplay]="data.vettingSafetyDisplay"
		[vettingOtherDisplay]="data.vettingOtherDisplay"
		[lastVettingTime]="data?.lastVettingTime"
		[infractionDetails]="data.infractionDetails"
	></app-quality>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end center" fxLayoutGap="1rem">
		<a (click)="closeDialog(null)">
			<span class="primary-text text-underline cursor-pointer"> Close </span>
		</a>
	</div>
</mat-dialog-actions>
